import React, { useState, useEffect, useRef } from "react";
import { Box, useMediaQuery } from "@mui/material";
import { BannerContainer, BannerText, BannerImageWrapper, CashbackBadge} from "./Styled";
import { CarouselContainer, SliderWrapper,  Slide, DotContainer, Dot } from "../../Styled";

// Distância mínima (px) do arrasto para trocar de banner
const SWIPE_THRESHOLD = 50;

export default function CarouselGeneric({ banners }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [dragOffset, setDragOffset] = useState(0);
    const [dragging, setDragging] = useState(false);
    const isMobile = useMediaQuery("(max-width: 768px)");
    const isTablet = useMediaQuery("(min-width: 769px) and (max-width: 1024px)");

    const startX = useRef(0);
    const isDragging = useRef(false);
    const hasMoved = useRef(false);

    // Reinicia a contagem a cada troca (automática ou por swipe/dot)
    useEffect(() => {
        const interval = setInterval(() => {
        if (!isDragging.current) handleNext();
        }, 4000);
        return () => clearInterval(interval);
    }, [currentIndex]);

    const handleNext = () => {
        setCurrentIndex((prev) =>
        prev === banners.length - 1 ? 0 : prev + 1
        );
    };

    const handlePrev = () => {
        setCurrentIndex((prev) =>
        prev === 0 ? banners.length - 1 : prev - 1
        );
    };

    const handleTouchStart = (e) => {
        startX.current = e.touches[0].clientX;
        isDragging.current = true;
        hasMoved.current = false;
        setDragging(true);
    };

    const handleTouchMove = (e) => {
        if (!isDragging.current) return;
        const diff = startX.current - e.touches[0].clientX;
        if (Math.abs(diff) > 5) hasMoved.current = true;
        setDragOffset(diff);
    };

    const handleTouchEnd = () => {
        if (dragOffset > SWIPE_THRESHOLD) {
            handleNext();
        } else if (dragOffset < -SWIPE_THRESHOLD) {
            handlePrev();
        }

        setDragOffset(0);
        setDragging(false);
        isDragging.current = false;
    };

    const handleClickBanner = (url) => {
        // Arrastar o carrossel não deve abrir o link do banner
        if (hasMoved.current) {
        hasMoved.current = false;
        return;
        }

        if (url) {
        window.open(url, "_blank");
        }
    };

    return (
        <CarouselContainer>
            <SliderWrapper
                index={currentIndex}
                dragOffset={dragOffset}
                dragging={dragging}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                {banners.map((item, i) => (
                <Slide key={i}>
                    {/* Caso 1: Imagem simples de fundo */}
                    {item.desktop && item.mobile ? (
                    <Box
                        sx={{
                        width: "100%",
                        height: isMobile ? "197px" : "364px",
                        backgroundImage: `url(${isMobile ? item.mobile : item.desktop})`,
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        borderRadius: "8px",
                        // backgroundColor: "#0B204D",
                        cursor: "pointer",
                        // margin: "0 1rem",
                        margin:  isMobile ? "0" : isTablet ? "0 1rem" : "0 2rem",
                        }}
                        onClick={() => handleClickBanner(item.url)}
                    />
                    ) : (
                        // Caso 2: Banner com conteúdo (logo, texto, botão)
                        <BannerContainer
                            sx={{ backgroundColor: item.cor || "#0A2342" }}
                            onClick={() => handleClickBanner(item.slug)}
                        >
                            <BannerText>
                                {item.cashback && (
                                    <CashbackBadge>{item.cashback}</CashbackBadge>
                                )}
                                <h1 style={{fontSize: isMobile ? "22px" : "32px"}}>{item.loja}</h1>
                                <p style={{ maxWidth: "90%", fontSize: isMobile ? "14px" : "1.2rem" }}>{item.descricao}</p>
                                <Box
                                    component="button"
                                    sx={{
                                    backgroundColor: "#FFD700",
                                    border: "none",
                                    borderRadius: "8px",
                                    fontWeight: "bold",
                                    padding: isMobile ? "0.5rem 1rem" : "0.7rem 1.2rem",
                                    cursor: "pointer",
                                    width: isMobile ? "100%" : "250px",
                                    maxWidth: "100%",
                                    fontSize: isMobile ? "14px" : "1rem",
                                    }}
                                >
                                    Aproveite agora
                                </Box>
                            </BannerText>

                            <BannerImageWrapper>
                            <Box
                                component="img"
                                src={item.imagem || "https://via.placeholder.com/200"}
                                alt={`Logo ${item.loja}`}
                                sx={{
                                width: isMobile ? "120px" : "200px",
                                height: isMobile ? "120px" : "200px",
                                objectFit: "contain",
                                borderRadius: "50%",
                                backgroundColor: "#ffffff",
                                }}
                            />
                            </BannerImageWrapper>
                        </BannerContainer>
                        )}
                </Slide>
                ))}
            </SliderWrapper>

            {/* Dots */}
            <DotContainer>
                {banners.map((_, index) => (
                <Dot
                    key={index}
                    active={index === currentIndex ? 1 : 0}
                    onClick={() => setCurrentIndex(index)}
                />
                ))}
            </DotContainer>
        </CarouselContainer>
    );
}
